'use client';

import { useState } from 'react';
import { ReviewQueueCard } from '@/components/orcamento/ReviewQueueCard';
import type { ReviewQueueItem, ReviewQueueResponse } from '@/types';

interface Props {
  queue: ReviewQueueResponse | undefined;
  /** Composite `reviewItemKey` of the busy row. */
  confirmingId: string | null;
  onConfirmRefund: (item: ReviewQueueItem) => void;
  onAlterRefund: (item: ReviewQueueItem) => void;
  onKeepAsExpense: (item: ReviewQueueItem) => void;
  onDismissRefund: (item: ReviewQueueItem) => void;
}

/**
 * The transactions page's refund review slice — renders nothing while the queue
 * loads or when there is nothing to review; the card only appears with work in it.
 */
export function RefundReviewCard({
  queue,
  confirmingId,
  onConfirmRefund,
  onAlterRefund,
  onKeepAsExpense,
  onDismissRefund,
}: Props) {
  const [open, setOpen] = useState(false);

  if (!queue || queue.total === 0 || queue.results.length === 0) return null;

  return (
    <ReviewQueueCard
      items={queue.results}
      total={queue.total}
      open={open}
      onOpenChange={setOpen}
      confirmingId={confirmingId}
      confirmingAll={false}
      onConfirmRefund={onConfirmRefund}
      onAlterRefund={onAlterRefund}
      onKeepAsExpense={onKeepAsExpense}
      onDismissRefund={onDismissRefund}
    />
  );
}
